// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero_oAteH","content":"Hero_content_MbZ6d","image":"Hero_image_gio6E","visible":"Hero_visible_dORIN"};